import { __assign, __awaiter, __generator, __rest } from "tslib";
import { doGet } from '../request/request';
import { ADV_QUERY, PRODUCT_QUERY } from './const';
import { groupArray } from '../utils/array';
// 接口一次最多请求ids数
var MAX_QUERY_ID = 15;
/**
 * 按广告组ID批量查询广告组详情
 * @param query MaterialQueryBaseParam
 */
export function queryAdvs(query) {
    return __awaiter(this, void 0, void 0, function () {
        var ret, _a, advertGroup, rest;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all(groupArray(query.ids, MAX_QUERY_ID)
                        .map(function (ids) { return _queryAdvs(__assign(__assign({}, query), { ids: ids })); }))
                    // 所有分组成功
                ];
                case 1:
                    ret = _b.sent();
                    // 所有分组成功
                    if (ret.every(function (r) { return r.subCode === '0'; })) {
                        _a = ret[0], advertGroup = _a.advertGroup, rest = __rest(_a, ["advertGroup"]);
                        return [2 /*return*/, __assign(__assign({}, rest), { advertGroup: ret.reduce(function (prev, curr) {
                                    return __assign(__assign({}, prev), curr.advertGroup);
                                }, {}) })];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function _queryAdvs(query) {
    return __awaiter(this, void 0, void 0, function () {
        var ids, rest;
        return __generator(this, function (_a) {
            ids = query.ids, rest = __rest(query, ["ids"]);
            return [2 /*return*/, doGet(ADV_QUERY, __assign({ ids: query.ids.join(",") }, rest))];
        });
    });
}
/**
 * 按商品组ID批量查询商品组详情
 * @param query MaterialQueryBaseParam
 */
export function queryProducts(query) {
    return __awaiter(this, void 0, void 0, function () {
        var ret, _a, productGroup, rest;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all(groupArray(query.ids, MAX_QUERY_ID)
                        .map(function (ids) { return _queryProducts(__assign(__assign({}, query), { ids: ids })); }))
                    // 所有分组成功
                ];
                case 1:
                    ret = _b.sent();
                    // 所有分组成功
                    if (ret.every(function (r) { return r.subCode === '0'; })) {
                        _a = ret[0], productGroup = _a.productGroup, rest = __rest(_a, ["productGroup"]);
                        return [2 /*return*/, __assign(__assign({}, rest), { productGroup: ret.reduce(function (prev, curr) {
                                    return __assign(__assign({}, prev), curr.productGroup);
                                }, {}) })];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function _queryProducts(query) {
    return __awaiter(this, void 0, void 0, function () {
        var ids, rest;
        return __generator(this, function (_a) {
            ids = query.ids, rest = __rest(query, ["ids"]);
            return [2 /*return*/, doGet(PRODUCT_QUERY, __assign({ ids: query.ids.join(",") }, rest))];
        });
    });
}
